import React, { useEffect, useState } from 'react';
import { ListItem, ListItemText, Collapse, Box } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import { randomString } from '../../../../../../../utilities/randomUtilities';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { BACKGROUND_REFLECTION_TYPE } from '../../../../Preview/PreviewDisplayConstants';

const styles = theme => ({
    item: {
        background: theme.palette.action.hover,
    },
    collapse: {
        backgroundColor: theme.palette.background.paperDark
    },
    group: {
        width: '100%',
    },
    button: {
        flex: '1 0 auto',
        height: theme.spacing(4),
        color: 'rgba(255, 255, 255, 0.48)',
        background: 'rgba(0, 0, 0, 0.2)',
        border: '1px solid rgba(255, 255, 255, 0.23)',
        transition: theme.transitions.create('background', {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.shortest,
        })
    },
});

const reflectionOptions = [
    { value: BACKGROUND_REFLECTION_TYPE.NONE, text: 'None' },
    { value: BACKGROUND_REFLECTION_TYPE.TWO_WAY, text: '2-way' },
    { value: BACKGROUND_REFLECTION_TYPE.FOUR_WAY, text: '4-way' }
];

const BackdropReflectionRadioButton = (props) => {
    const { classes, children, selectedType, checked, text, toolTip, warning, onChange, expansionEnabled, ...other } = props;
    const [labelId] = useState(randomString());
    const [expanded, setExpanded] = useState(false);

    useEffect(() =>
        setExpanded(selectedType != BACKGROUND_REFLECTION_TYPE.NONE),
        [selectedType])

    return (
        <>
            <ListItem
                {...other}
                aria-expanded={expanded}
                className={expanded ? classes.item : null}
                button={expansionEnabled}
            >
                <ListItemText>
                    {text}
                </ListItemText>
                <Box>
                    <ToggleButtonGroup
                        value={selectedType}
                        exclusive
                        onChange={(_, value) => value != null && onChange(value)}
                        aria-labelledby={labelId}
                        size='small'
                        className={classes.group}
                    >
                        {reflectionOptions.map((option) =>
                            <ToggleButton
                                value={option.value}
                                key={option.value}
                                className={classes.button}
                            >
                                {option.text}
                            </ToggleButton>
                        )}
                    </ToggleButtonGroup>
                </Box>
            </ListItem>
            <Collapse
                in={expanded}
                timeout='auto'
                unmountOnExit
                className={classes.collapse}
            >
                {children}
            </Collapse>
        </>
    );
}

export default withStyles(BackdropReflectionRadioButton, styles);